import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable, catchError } from 'rxjs';
import { inject } from '@angular/core';

export class BaseApiService {
  private oidcJwt: string | undefined;

  cookieService = inject(CookieService);

  constructor(
    private http: HttpClient,
    private apiBaseUrl: string,
  ) {
    this.oidcJwt = this.cookieService.get('oidc_jwt');
  }

  get<T>(endpoint: string): Observable<T> {
    return this.http.get<T>(
      `${this.apiBaseUrl}/${endpoint}`,
      { headers: this.buildHeaders() }
    );
  }

  post<T>(endpoint: string, data: any): Observable<T> {
    return this.http.post<T>(
      `${this.apiBaseUrl}/${endpoint}`,
      data,
      { headers: this.buildHeaders() }
    );
  }

  put<T>(endpoint: string, data: any): Observable<T> {
    return this.http.put<T>(
      `${this.apiBaseUrl}/${endpoint}`,
      data,
      { headers: this.buildHeaders() }
    );
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(
      `${this.apiBaseUrl}/${endpoint}`,
      { headers: this.buildHeaders() }
    );
  }

  buildHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    if (this.oidcJwt) {
      headers = headers.set('Authorization', `Bearer ${this.oidcJwt}`);
    }
    return headers;
  }
}
